export const NAME = 'AreebaFan'